const l = {
  name: "Boat",
  dimensions: { width: 40, height: 30 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 30" style="enable-background:new 0 0 40 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,0h-6v19.1l-7.3,1.1l1.8,5.9c-0.1-0.1-0.2-0.2-0.3-0.3C3.2,24.9,2,24,0,24v2c1.3,0,2.1,0.5,2.8,1.2
			c0.1,0.1,0.3,0.3,0.4,0.4c0.6,0.6,1.3,1.3,2.3,1.8l0,0L6,29.7C6.6,29.9,7.2,30,8,30c2.4,0,3.7-1.3,4.7-2.3l0,0
			c1-1,1.7-1.7,3.3-1.7c1.6,0,2.3,0.7,3.3,1.7l0,0c1,1,2.3,2.3,4.7,2.3c2.4,0,3.7-1.3,4.7-2.3l0,0c1-1,1.7-1.7,3.3-1.7
			c1,0,1.7,0.3,2.3,0.8l0,0l0.1,0.1c0.3,0.2,0.6,0.5,0.9,0.8l0.1,0.1c0.3,0.3,0.7,0.7,1.1,1c0.9,0.7,2,1.3,3.6,1.3v-2
			c-1.1,0-1.8-0.4-2.4-0.8c-0.3-0.3-0.6-0.5-0.9-0.9l0,0c-0.2-0.2-0.4-0.4-0.7-0.6l2.3-10.8L33,15.6V8h-3V4H16V0z M33,17.6L33,17.6
			l2.7-0.4l-1.5,7.2C33.6,24.2,32.9,24,32,24c-2.4,0-3.7,1.3-4.7,2.3l0,0c-1,1-1.7,1.7-3.3,1.7c-1.6,0-2.3-0.7-3.3-1.7l0,0
			c-1-1-2.3-2.3-4.7-2.3c-2.4,0-3.7,1.3-4.7,2.3l0,0c-1,1-1.7,1.7-3.3,1.7c-0.3,0-0.6,0-0.9-0.1l-1.8-6.1l4.7-0.7v0l17.2-2.6
			L33,17.6z M31,14v1.9l-3,0.5V14H31z M26,14v2.7l-2.6,0.4L23,17.1V14H26z M21,12v5.4l-5,0.8V10h15v2H21z M28,8H16V6h12V8z M14,2
			v16.5l-2,0.3V2H14z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Boat
};
